import { useEffect, useRef } from 'react';

// Set your three main locations here (fill coords)
const MARKERS = [
  { title: 'Deák tér', lat: 47.680816, lng: 16.586416 },
  { title: 'Erzsébet Kert', lat: 47.683198, lng: 16.574185 },
  { title: 'Fő tér', lat: 47.686356, lng: 16.591171 }
];

function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement('script');
    s.src = src; s.async = true; s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load Google Maps script'));
    document.head.appendChild(s);
  });
}

export default function GoogleMap() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const key = 'AIzaSyCcV4aioIq8MXDI49o2WDGZfBfvPtckj0k';

    loadScript(`https://maps.googleapis.com/maps/api/js?key=${key}`).then(() => {
      // @ts-ignore
      const google = (window as any).google as typeof window.google;
      if (!google || !ref.current) return;

      const center = { lat: MARKERS[0].lat, lng: MARKERS[0].lng };
      const map = new google.maps.Map(ref.current, {
        center, zoom: 14, mapTypeControl: false, streetViewControl: false, fullscreenControl: false
      });
      MARKERS.forEach(m => {
        new google.maps.Marker({
            position: { lat: m.lat, lng: m.lng },
            map,
            title: m.title, // still shows on hover
            label: {
            text: m.title,
            color: "#1e90ff",
            fontSize: "14px",
            fontWeight: "600",
            className: "marker-label"
            }
        });
        });

      // Fit bounds around all markers
      const bounds = new google.maps.LatLngBounds();
      MARKERS.forEach(m => bounds.extend({ lat: m.lat, lng: m.lng }));
      map.fitBounds(bounds);
    }).catch(console.error);
  }, []);

  return <div style={{ width: '100%', height: 380, borderRadius: 12, overflow: 'hidden', border: '1px solid #222' }} ref={ref} />;
}
